import React, { useState, useEffect } from "react";

import Breadcrumbs from "../../../components/Breadcrumbs";

import { useTranslation } from "react-i18next";

import Swal from "sweetalert2";

import AuthUser from "../../../components/AuthUser";
import { toast, ToastContainer } from 'react-toastify';
import Spinner from "../../../components/Spinner";
import BancoFilter from "../Administration/financas/BancoFilter";
import BancoTable from "../Administration/financas/BancoTable";
import BancoModal from "../../../components/Administration/financas/BancoModal";

const Banco = () => { 

  // eslint-disable-next-line no-unused-vars
  const { http, url_root, user_permissoes, verificarPermissao, getMissao } = AuthUser();
  const [bancos, setBancos] = useState([]);  

  const [filteredBancos, setfilteredBancos] = useState([]);

  const { t } = useTranslation();

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  // Callback function to receive filtered users from UserFilter
  const handleFilterSubmit = (filteredBancos) => {

    console.log('received:');
    console.log(filteredBancos);
     
    setfilteredBancos(filteredBancos); 
  };


  const handleSubmissionSuccess = (bancos) => {
    // Refresh acessos state or trigger any necessary actions
    setBancos(bancos);    
  };

  const getBancos = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get('/bancos/'+getMissao()?.id);

      setBancos(res.data.bancos);

      setLoading(false);

    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  }; 
 

  useEffect(() => {

    const fetchData = async () => {
      try {
        // Chama a função assíncrona getUtilizador()
        await getBancos();

      } catch (error) {
        console.error('Erro ao obter bancos:', error);
      }
    };

    // Chama a função fetchData() para iniciar o processo
    fetchData();
  }, []);

  if (verificarPermissao('CARGO', 'ver')) 
  if (loading) return (<><Spinner></Spinner></>); else return (
    <>
      (
      <>
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle={t('Banco')}
          title="Dashboard"
          subtitle={t('Bancos com que trabalhamos')}
          modal="#add_banco_modal"
          name={t('Add banco')}
        />

        <BancoFilter onFilterSubmit={handleFilterSubmit} />
        <BancoTable bancos={filteredBancos.length > 0 ? filteredBancos : bancos} />
        <BancoModal onSubmissionSuccess={handleSubmissionSuccess} />

      </div>
    </div> </>
        ); </>
    );
  else
    return (<>
      <div className="page-wrapper cardhead">
        <div className="content ">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">SEM PERMISSÃO</h3>

              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">

              <div className="card">
                <div className="card-header">
                  <h4 className="card-title"><i className="fa fa-times-circle text-danger"></i>&nbsp; OPERAÇÃO NÃO AUTORIZADA</h4>
                </div>
                <div className="card-body">
                  <p>
                    Esta operação não é autorizada para o seu nivel de acesso ao sistema, por favor contacte o administrador do sistema.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>)
};


export default Banco;
